import React from 'react';
import { FacebookIcon, InstagramIcon, StarIcon, PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer style={{
    backgroundColor: '#025A8A'
  }} data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-139">
        {/* Top Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-140">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/3rDr76G2xKESSQAdSYdtBE/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-12 mb-4" data-id="element-142" />
            <p style={{
            color: 'rgba(255,255,255,0.65)',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            lineHeight: 1.7
          }} data-id="element-143">
              Professional power washing and exterior cleaning for residential
              and commercial properties across the Phoenix metro area.
            </p>
          </div>

          {/* Services */}
          <div data-id="element-144">
            <h4 className="font-bold text-white mb-5 uppercase tracking-widest" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '13px'
          }} data-id="element-145">
              Services
            </h4>
            <ul className="flex flex-col gap-2.5" data-id="element-146">
              <li data-id="element-147">
                <a href="/services/backyard-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-148">
                  Backyard Cleaning
                </a>
              </li>
              <li data-id="element-149">
                <a href="/services/commercial-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-150">
                  Commercial Cleaning
                </a>
              </li>
              <li data-id="element-151">
                <a href="/services/driveway-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-152">
                  Driveway Cleaning
                </a>
              </li>
              <li data-id="element-153">
                <a href="/services/paver-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-154">
                  Paver Cleaning
                </a>
              </li>
              <li data-id="element-155">
                <a href="/services/solar-panel-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-156">
                  Solar Panel Cleaning
                </a>
              </li>
              <li data-id="element-157">
                <a href="/services/trash-can-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-158">
                  Trash Can Cleaning
                </a>
              </li>
              <li data-id="element-159">
                <a href="/services/window-cleaning" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-160">
                  Window Cleaning
                </a>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div data-id="element-161">
            <h4 className="font-bold text-white mb-5 uppercase tracking-widest" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '13px'
          }} data-id="element-162">
              Locations
            </h4>
            <ul className="flex flex-col gap-2.5" data-id="element-163">
              {[{
              name: 'Ahwatukee Foothills',
              slug: 'ahwatukee-foothills'
            }, {
              name: 'Casa Grande',
              slug: 'casa-grande'
            }, {
              name: 'Chandler',
              slug: 'chandler'
            }, {
              name: 'Gilbert',
              slug: 'gilbert'
            }, {
              name: 'Litchfield Park',
              slug: 'litchfield-park'
            }, {
              name: 'Maricopa',
              slug: 'maricopa'
            }, {
              name: 'Mesa',
              slug: 'mesa'
            }, {
              name: 'Phoenix',
              slug: 'phoenix'
            }, {
              name: 'Queen Creek',
              slug: 'queen-creek'
            }, {
              name: 'Scottsdale',
              slug: 'scottsdale'
            }, {
              name: 'Sun Lakes',
              slug: 'sun-lakes'
            }, {
              name: 'Tempe',
              slug: 'tempe'
            }].map(city => <li key={city.slug} data-id="element-164">
                  <a href={`/locations/${city.slug}`} className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-165">
                    {city.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-166">
            <h4 className="font-bold text-white mb-5 uppercase tracking-widest" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '13px'
          }} data-id="element-167">
              Contact
            </h4>
            <ul className="flex flex-col gap-4" data-id="element-168">
              <li data-id="element-169">
                <a href="tel:4805998442" className="flex items-center gap-3 text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-170">
                  <PhoneIcon className="h-4 w-4 flex-shrink-0" style={{
                  color: '#7BC4EA'
                }} data-id="element-171" />
                  (480) 599-8442
                </a>
              </li>
              <li data-id="element-172">
                <div className="flex items-start gap-3 text-sm" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-173">
                  <MapPinIcon className="h-4 w-4 flex-shrink-0 mt-0.5" style={{
                  color: '#7BC4EA'
                }} data-id="element-174" />
                  <span data-id="element-175">
                    45004 W. Garvey Ave.
                    <br data-id="element-176" />
                    Maricopa, AZ 85139
                  </span>
                </div>
              </li>
              <li data-id="element-177">
                <a href="mailto:info@bluecactuspowerwashing.com" className="flex items-center gap-3 text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-178">
                  <MailIcon className="h-4 w-4 flex-shrink-0" style={{
                  color: '#7BC4EA'
                }} data-id="element-179" />
                  info@bluecactuspowerwashing.com
                </a>
              </li>
              <li data-id="element-180">
                <div className="flex items-start gap-3 text-sm" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-181">
                  <ClockIcon className="h-4 w-4 flex-shrink-0 mt-0.5" style={{
                  color: '#7BC4EA'
                }} data-id="element-182" />
                  <span data-id="element-183">
                    Mon–Sat: 7:00 AM – 6:00 PM
                    <br data-id="element-184" />
                    Sunday: Closed
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t mb-8" style={{
        borderColor: 'rgba(255,255,255,0.12)'
      }} data-id="element-185" />

        {/* Bottom Row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-186">
          <p className="text-sm text-center sm:text-left" style={{
          color: 'rgba(255,255,255,0.45)',
          fontFamily: 'Inter, sans-serif',
          fontSize: '13px'
        }} data-id="element-187">
            © 2024 Blue Cactus Power Washing. All rights reserved. | Powered by{' '}
            <span style={{
            color: 'rgba(255,255,255,0.6)'
          }} data-id="element-188">
              Luguensi
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-189">
            {[{
            icon: <FacebookIcon className="h-4 w-4" data-id="element-190" />,
            label: 'Facebook',
            href: 'https://www.facebook.com/people/Blue-Cactus-Power-Washing/100087759273733/#'
          }, {
            icon: <InstagramIcon className="h-4 w-4" data-id="element-191" />,
            label: 'Instagram',
            href: 'https://www.instagram.com/bluecactuspowerwashing'
          }, {
            icon: <StarIcon className="h-4 w-4" data-id="element-192" />,
            label: 'Google Reviews',
            href: 'https://share.google/uDUGzbAlF3nHOVPWX'
          }].map(({
            icon,
            label,
            href
          }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors hover:bg-blue-600" style={{
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: 'rgba(255,255,255,0.7)'
          }} aria-label={label} data-id="element-193">
                {icon}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
}